import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">
            About UNI-Connect
          </CardTitle>
          <CardDescription className="text-center">
            Important Information
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-muted p-4 rounded-lg border border-border">
            <p className="text-sm text-muted-foreground leading-relaxed">
              This tool is provided "as is" without any warranties, guarantees, or liability of any kind. 
              Use of the tool is at your own risk. No data entered will be stored, logged, or shared. 
              The tool is intended for convenience only and should not be relied upon as a definitive or error-free solution.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="font-semibold text-lg">Purpose</h3>
            <p className="text-sm text-muted-foreground">
              UNI-Connect helps you connect transaction lines to categories in the finance dashboard, 
              based on account, team and project ranges.
            </p>
          </div>

          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to App
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default About;
